import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DoNotDisturbIcon = (props: IconProps) => (
  <Icon width="10px" height="10px" viewBox="0 0 10 10" {...props}>
    <path d="M8.75 5C8.75 2.92893 7.07107 1.25 5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75V10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10V8.75C7.07107 8.75 8.75 7.07107 8.75 5Z" />
    <path d="M6.25 5C6.25 5.69036 5.69036 6.25 5 6.25C4.30964 6.25 3.75 5.69036 3.75 5C3.75 4.30964 4.30964 3.75 5 3.75C5.69036 3.75 6.25 4.30964 6.25 5Z" />
    <circle cx="5" cy="5" r="5" />
    <rect x="1.25" y="3.75" width="7.5" height="2.5" fill="white" />
  </Icon>
);

export default memo(DoNotDisturbIcon);
